import { Youtube } from "lucide-react";
import Link from "next/link";
import { Button } from "@/components/ui/button";
import type { UserProfile } from "../utils";

interface SocialLinksProps {
  profile: UserProfile;
}

export function SocialLinks({ profile }: SocialLinksProps) {
  const hasSocialLinks =
    profile.twitchUsername ||
    profile.youtubeChannelUrl ||
    profile.twitterHandle;

  if (!hasSocialLinks) {
    return null;
  }

  return (
    <div className="flex flex-wrap gap-3">
      {profile.twitchUsername && (
        <Button asChild size="sm" variant="outline">
          <Link
            href={`https://twitch.tv/${profile.twitchUsername}`}
            rel="noopener noreferrer"
            target="_blank"
          >
            <svg
              aria-label="Twitch"
              className="mr-2 h-4 w-4"
              fill="currentColor"
              role="img"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <title>Twitch</title>
              <path d="M11.571 4.714h1.715v5.143H11.57zm4.715 0H18v5.143h-1.714zM6 0L1.714 4.286v15.428h5.143V24l4.286-4.286h3.428L22.286 12V0zm14.571 11.143l-3.428 3.428h-3.429l-3 3v-3H6.857V1.714h13.714Z" />
            </svg>
            Twitch
          </Link>
        </Button>
      )}

      {profile.youtubeChannelUrl && (
        <Button asChild size="sm" variant="outline">
          <Link
            href={profile.youtubeChannelUrl}
            rel="noopener noreferrer"
            target="_blank"
          >
            <Youtube className="mr-2 h-4 w-4" />
            YouTube
          </Link>
        </Button>
      )}

      {profile.twitterHandle && (
        <Button asChild size="sm" variant="outline">
          <Link
            href={`https://x.com/${profile.twitterHandle}`}
            rel="noopener noreferrer"
            target="_blank"
          >
            <svg
              aria-label="X / Twitter"
              className="mr-2 h-4 w-4"
              fill="currentColor"
              role="img"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <title>X / Twitter</title>
              <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
            </svg>
            X / Twitter
          </Link>
        </Button>
      )}
    </div>
  );
}
